module.exports = __webpack_public_path__ + "img/soheil.af2ce4d6.jpeg";